import './polyfills';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import 'mapbox-gl/dist/mapbox-gl.css';

import App from './App';

ReactDOM.render(<App />, document.getElementById('root') as HTMLElement);
